const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStressEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.716,
    height: 664.235,
    viewBox: "0 0 211.856 175.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffdada",
      strokeWidth: 6.52743292,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffd9d0",
      strokeWidth: 5.42192125,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m258 73.8-28.6-19.4 14-39.8-27.9 26.8-33.4-28.1 13.6 35.2c-2.3-.3-5.3-1.3-8.7-3.6-8.7-6.1-10.6-12.7-12.6-19.8-1.6-5.6-3.3-11.4-8.4-16.4-7-6.9-15.8-8.3-23.4-3.9-5.3 3.1-8.8 8.2-9.6 13.6L116.6 11l-7.8 17.3c-4.6-.7-9.2-1.1-14-1.1C43.5 27.3 2 68.8 2 120c0 51.2 41.5 92.8 92.8 92.8s92.8-41.5 92.8-92.8c0-16.9-4.5-32.7-12.4-46.3l21.5-4.3-6 27.7 22.8-14.2 29.8 32.6L230 70.7zM150.1 45.6l7.3-16.2-18.1-8.2c-.1-4.1 2.5-8.4 6.6-10.8 5-2.9 10.7-1.9 15.5 2.9 3.9 3.8 5.1 8.3 6.6 13.5 2.1 7.5 4.6 16 15.2 23.4 3.1 2.1 6 3.4 8.5 4.1l-21.2 12.3c-5.6-8.1-12.6-15.2-20.4-21z",
    transform: "matrix(.8141 0 0 .8141 .579 .297)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffded6",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5.31400013,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M36.473 147.733c2.063-19.962 27.557-14.738 28.005 0 0 7.734-6.268 14.003-14.002 14.003-7.734-.081-14.003-6.269-14.003-14.003zm76.037 48.602-11.56-9.118-13.921 10.99-13.921-10.99-14.084 10.99-16.282-12.862 4.721-6.024 11.56 9.118 13.922-10.99 13.921 10.99 13.921-10.99 16.364 12.862zm-3.012-34.68c-7.734 0-14.003-6.269-14.003-14.003 2.063-19.963 27.558-14.738 28.006 0a13.95 13.95 0 0 1-14.003 14.003z",
    transform: "translate(-2.272 -61.711)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressEmpty);
export default __webpack_public_path__ + "static/media/stress_empty.011df9850f0cf030f2544a8897d6818b.svg";
export { ForwardRef as ReactComponent };